// extracted by mini-css-extract-plugin
module.exports = {"item":"_Accordion_item__2W5cS","head":"_Accordion_head__1pqM7","title":"_Accordion_title__3Sd9E"};